var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDollarM(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 2H18V4H6V2ZM4 6V4H6V6H4ZM4 18V6H2V18H4ZM6 20V18H4V20H6ZM18 20V22H6V20H18ZM20 18V20H18V18H20ZM20 6H22V18H20V6ZM20 6V4H18V6H20ZM11 5H13V7H16V9H13H11H10V11H14H16V13V15V17H14H13V19H11V17H8V15H11H13H14V13H10H8V11V9V7H10H11V5Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDollarM);
export default __webpack_public_path__ + "static/media/dollar-m.f6a3accd4f35d8869e410001cedac7bc.svg";
export { ForwardRef as ReactComponent };